import * as BABYLON from "babylonjs";

export class SkyMesh extends BABYLON.Mesh {
    skybox: BABYLON.Mesh;
    skyboxMaterial: BABYLON.StandardMaterial;
    constructor(scene: BABYLON.Scene, pathToTextures: string) {
        super("SkyMesh", scene);
        this.skybox = BABYLON.MeshBuilder.CreateBox("skyBox", { size: 1.0 }, scene);
        this.skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
        this.skyboxMaterial.backFaceCulling = false;
        this.skyboxMaterial.reflectionTexture = new BABYLON.CubeTexture(pathToTextures, scene, undefined, true);
        this.skyboxMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        this.skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
        this.skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
        this.skybox.material = this.skyboxMaterial;
        this.infiniteDistance = true;
        this.skybox.parent = this;
        this.skybox.renderingGroupId = -1;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/display/skyMesh.ts